import { Link } from "react-router-dom";

const footerLinks = {
  热门分类: [
    { name: "电视剧", path: "/category/tv-series" },
    { name: "电影", path: "/category/movies" },
    { name: "综艺", path: "/category/variety" },
    { name: "动漫", path: "/category/anime" },
    { name: "纪录片", path: "/category/documentary" },
  ],
  热门资源: [
    { name: "香蕉视频", path: "/" },
    { name: "糖豆视频", path: "/" },
    { name: "小蓝视频", path: "/" },
    { name: "蓝莓视频", path: "/" },
  ],
  关于我们: [
    { name: "品牌介绍", path: "/about" },
    { name: "联系我们", path: "/about" },
    { name: "用户口碑", path: "/about" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="text-2xl">🌹</span>
                <span className="text-xl font-heading text-background-50">玫瑰视频</span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed">
                玫瑰视频汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门影视资源，高清免费在线观看，海量电视剧全集和电影大全每日更新，满足各类追剧需求。
              </p>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4">
                  {title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-400">
                &copy; {new Date().getFullYear()} 玫瑰视频 meiguishipin.com. All rights reserved.
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                  隐私政策
                </a>
                <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                  服务条款
                </a>
                <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                  DMCA
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}